import React, { useCallback, useEffect } from "react";
import WebLayout from "../../layout/WebLayout";
import profileAction from "../../stores/actions/profileAction";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../stores";
import { Link } from "react-router-dom";
import DashboardModal from "../../components/DashboardModal";

const Dashboard = () => {
  const dispatch = useDispatch<any>();
  const { profileDetails } = useSelector((state: RootState) => state.auth);
  const { dashboardData } = useSelector((state: RootState) => state.profile);

  const getDashboardData = useCallback(async () => {
    await dispatch(profileAction.getDashboardData());
    await dispatch(profileAction.getLatestMessage());
    await dispatch(
      profileAction.getNotifications({
        limit: 2,
        search: "",
        page: 1,
        type: "SELLER",
      })
    );
    await dispatch(
      profileAction.getNotifications({
        limit: 2,
        search: "",
        page: 1,
        type: "BUYER",
      })
    );
  }, [dispatch]);

  useEffect(() => {
    getDashboardData();
  }, [getDashboardData, profileDetails?.delivArea]);

  return (
    <WebLayout pageName={"Dashboard"}>
      <div className={"content-wrapper"}>
        <div className="container-fluid">
          <DashboardModal />
          <div className={"row"}>
            <div className="col-sm-12 col-lg-12 mt-3">
              <div className="row">
                <div className="col-sm-6 col-lg-3 p-1">
                  <div className="card card-border-shadow-warning">
                    <Link to="/my-orders/pending" className="text-gray">
                      <div className="card-body p-3">
                        <div className="d-flex justify-content-between align-items-start card-widget-1">
                          <div>
                            <h4 className="mb-1">
                              {dashboardData?.buyerVerificationPending}
                            </h4>
                          </div>
                          <span className="badge text-black">
                            <i
                              className="bx bx-box "
                              style={{ fontSize: "24px" }}></i>
                          </span>
                        </div>
                        <p className="mb-0 h6 text-field">Order Placed</p>
                      </div>
                    </Link>
                  </div>
                </div>
                <div className="col-sm-6 col-lg-3 p-1">
                  <div className="card card-border-shadow-info">
                    <Link to="/my-orders/placed" className="text-gray">
                      <div className="card-body p-3">
                        <div className="d-flex justify-content-between align-items-start card-widget-1">
                          <div>
                            <h4 className="mb-1">
                              {dashboardData?.buyerDispatchedPending}
                            </h4>
                          </div>
                          <span className="badge text-black">
                            <i
                              className="bx bx-category "
                              style={{ fontSize: "24px" }}></i>
                          </span>
                        </div>
                        <p className="mb-0  h6 text-field">Order Dispatch</p>
                      </div>
                    </Link>
                  </div>
                </div>

                <div className="col-sm-6 col-lg-3 p-1">
                  <div className="card card-border-shadow-primary">
                    <Link to="/my-orders/dispatch" className="text-gray">
                      <div className="card-body p-3">
                        <div className="d-flex justify-content-between align-items-start card-widget-1">
                          <div>
                            <h4 className="mb-1">
                              {dashboardData?.buyerReceivedPending}
                            </h4>
                          </div>
                          <span className="badge text-black">
                            <i
                              className="bx bx-cart "
                              style={{ fontSize: "24px" }}></i>
                          </span>
                        </div>
                        <p className="mb-0  h6 text-field">Order Received</p>
                      </div>
                    </Link>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </WebLayout>
  );
};

export default Dashboard;
